import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthParams {
  telegramId: string | null;
  yandexId: string | null;
}

interface StartupParamsState {
  auth: AuthParams;
  serviceType: string | null;
  setStartupParams: (params: {
    telegramId: string | null;
    yandexId?: string | null;
    serviceType: string | null;
  }) => void;
  initializeFromSearch: (search: string) => void;
}

export const useStartupParamsStore = create<StartupParamsState>()(
  persist(
    (set) => ({
      auth: {
        telegramId: null,
        yandexId: null,
      },
      serviceType: null,
      setStartupParams: ({ telegramId, yandexId, serviceType }) =>
        set((state) => ({
          auth: {
            telegramId,
            yandexId: yandexId ?? state.auth.yandexId,
          },
          serviceType,
        })),
      initializeFromSearch: (search) => {
        const params = new URLSearchParams(search);

        set((state) => {
          const telegramId = params.get("telegram_id");
          const yandexId = params.get("yandex_id");
          const serviceType = params.get("service_type");

          return {
            auth: {
              telegramId: telegramId ?? state.auth.telegramId,
              yandexId: yandexId ?? state.auth.yandexId,
            },
            serviceType: serviceType ?? state.serviceType,
          };
        });
      },
    }),
    {
      name: "startup-params:store",
      partialize: (state) => ({
        auth: state.auth,
        serviceType: state.serviceType,
      }),
    }
  )
);
